import React, { useState } from 'react';
import pt from 'prop-types';
import {
  Box, Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions,
} from '@mui/material';
import { AnimatedLogOut } from 'Components/reactbits/AnimatedIcons';
import { useLogout } from 'Utils/useLogout';

/**
 * Shared Log out control — identical everywhere (settings, account): outlined
 * red at rest, red-filled with white text on hover, and a confirmation dialog
 * before the actual sign-out.
 */
const LogoutButton = ({ size, fullWidth }) => {
  const [hover, setHover] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const logout = useLogout();

  return (
    <>
      <Button
        variant="outlined"
        size={size}
        fullWidth={fullWidth}
        onClick={() => setConfirmOpen(true)}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        startIcon={(
          <Box sx={{ display: 'inline-flex' }}>
            <AnimatedLogOut size={16} strokeWidth={2.2} animate={hover} />
          </Box>
        )}
        sx={{
          borderRadius: 2,
          textTransform: 'none',
          fontWeight: 600,
          color: '#e5484d',
          borderColor: '#e5484d',
          '&:hover': { backgroundColor: '#e5484d', borderColor: '#e5484d', color: '#fff' },
        }}
      >
        Log out
      </Button>
      <Dialog
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        PaperProps={{ sx: { borderRadius: 3, fontFamily: '"Montserrat", sans-serif', maxWidth: 380 } }}
      >
        <DialogTitle sx={{ fontFamily: 'inherit', fontWeight: 700 }}>Log out?</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ fontFamily: 'inherit', color: 'text.secondary' }}>
            You&apos;ll need to sign in again to access your projector.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={() => setConfirmOpen(false)}
            sx={{ textTransform: 'none', borderRadius: 2, color: 'text.secondary', fontFamily: 'inherit' }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            disableElevation
            onClick={() => { setConfirmOpen(false); logout(); }}
            sx={{
              textTransform: 'none',
              borderRadius: 2,
              fontFamily: 'inherit',
              fontWeight: 600,
              backgroundColor: '#e5484d',
              '&:hover': { backgroundColor: '#c93b40' },
            }}
          >
            Log out
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

LogoutButton.propTypes = {
  size: pt.string,
  fullWidth: pt.bool,
};

LogoutButton.defaultProps = {
  size: 'small',
  fullWidth: false,
};

export default LogoutButton;
